module.exports = __webpack_public_path__ + "img/server-light.0847d384.svg";